<template>
    <div class="BankTabber">
        <div class="tab-header font-size-middle"
            v-for="(tab, index) in tabs"
            :key="index"
            @click="tabClicked(index)"
            :class="{
                active: index == activeTab
            }">
            {{ tab }}
        </div>
        <div class="selection-box" :style="{
            ['--tab-length']: `${100/tabs.length}%`,
            ['--tab-offset']: `${100/tabs.length * activeTab}%`,
        }"></div>
    </div>
</template>

<script>
    export default {
        name: 'BankTabber',
        components: {
        },
        props: {
            tabs: {
                type: Array,
                required: true,
            },
            activeTab: {
                type: Number,
                default: 0,
            },
        },
        methods: {
            tabClicked(index) {
                this.$emit('tabselected', index);
            },
        },
    };
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_variables.scss";

    .BankTabber {
        position: relative;
        display: flex;
        align-items: flex-start;
        margin: 20px 0;
        border: 1px solid $primary;
        border-radius: 20px;

        .tab-header {
            cursor: pointer;
            box-sizing: content-box;
            padding: 10px 20px;
            flex: 1 1;
            text-align: center;
            color: $primary;
            transition: color 0.1s ease-out 0.0s, border 0.1s ease-out;

            &.active {
                color: #eee;
                border-color: $primary;
            }
        }

        .selection-box {
            position: absolute;
            z-index: -1;
            top: 0;
            bottom: 0;
            border-top: 3px solid $primary;
            border-radius: 20px;
            background-color: $primary;
            width: var(--tab-length, 100px);
            left: var(--tab-offset, 0px);

            transition: 0.2s ease-out left;
        }
    }
</style>
